module.exports = __webpack_public_path__ + "static/unbreakable-zack-collie-2691829c3583199ad25694267d6aee14.jpg";